export default __webpack_public_path__ + "static/media/linkedin.ef6bea78.svg";